import { Injectable } from '@angular/core';
import { UserRole } from '@qaroni-app/workers/types/user-role';
import {
  adminOnlyRoles,
  fullAccessAdminRoles,
  UserRoleEnum,
} from '@qaroni-app/workers/types/user-role.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserRoleGuardService {
  private userRoleSubject = new BehaviorSubject<UserRole>(null);

  public getUserRole$() {
    return this.userRoleSubject.asObservable();
  }

  public setUserRole(userRole: UserRole) {
    this.userRoleSubject.next(userRole);
  }

  public isManager(currenRole: UserRoleEnum): boolean {
    return !fullAccessAdminRoles.includes(currenRole);
  }

  public hasAccess(role: UserRoleEnum, adminOnly = false): boolean {
    const allowedRoles = adminOnly ? adminOnlyRoles : fullAccessAdminRoles;

    return allowedRoles.includes(role);
  }
}
